(function () {
  function rewriteCookieLinks() {
    const links = document.querySelectorAll('a[href*="preview_privacy_banner=1"]');
    if (!links.length) return;

    const u = new URL(window.location.href);
    u.searchParams.set('preview_privacy_banner', '1');

    const target = u.pathname + '?' + u.searchParams.toString() + u.hash;
    links.forEach(a => a.setAttribute('href', target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteCookieLinks, { once: true });
  } else {
    rewriteCookieLinks();
  }

  document.addEventListener('shopify:section:load', rewriteCookieLinks);
})();